import React from "react";
// import moment from "moment"
import { format } from "date-fns";
import PropTypes from "prop-types";
import { query_generate } from "../../../utilities/_query_generate";

import LoadingCard from "./loadingCard";
import coverage_card_img from "./../../../img/dashboard_card/coverage_corner_image.svg";
import "./../styles/coverageCard.scss";
import useSWR from "swr";

/**
 * @description Newly designed MDO Coverage card.
 * @component Coverage Card
 * @category Dashboard
 * @author Zoha
 */
const fakeData = {
  total_outlet: 93071,
  today_coverage: {
    call_generates: 1025,
    percentage: 1.1,
  },
  yesterday_coverage: {
    call_generates: 3895,
    percentage: 4.18,
  },
  week_ago_coverage: {
    call_generates: 768,
    percentage: 0.83,
  },
  mtd_coverage: {
    call_generates: 60407,
    percentage: 64.9,
  },
};
const coverage_card = {
  card_heading: "MMO Visit Coverage",
  card_subheading: "Month to Date",
  api_link: `api/reports/v3/merchant-coverage-report`,
  conrner_right_top_img: coverage_card_img,
};

const options = {
  series: [
    {
      data: [400],
    },
  ],
  chart: {
    type: "bar",
    height: 350,
  },
  plotOptions: {
    bar: {
      borderRadius: 4,
      horizontal: true,
    },
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: ["South Korea"],
  },
};

const CoverageCard = (props) => {
  let query_pre_process = [
    {
      key: "team",
      values:
        props.filterElement.relational !== undefined
          ? props.filterElement.relational.team
          : [],
    },
    {
      key: "region",
      values:
        props.filterElement.relational !== undefined
          ? props.filterElement.relational.region
          : [],
    },
    {
      key: "area",
      values:
        props.filterElement.relational !== undefined
          ? props.filterElement.relational.area
          : [],
    },
    {
      key: "territory",
      values:
        props.filterElement.relational !== undefined
          ? props.filterElement.relational.territory
          : [],
    },
    {
      key: "agency",
      values:
        props.filterElement.relational !== undefined
          ? props.filterElement.relational.agency
          : [],
    },
  ];
  let query = query_generate(query_pre_process);

  const url = `${process.env.REACT_APP_API_URL}/${
    coverage_card["api_link"]
  }?date=${
    //moment(props.date).format("yyyy-MM-dd")
    format(new Date(props.date), "yyyy-MM-dd")
  }${query !== "" ? "&" + query : ""}`;

  const { data: coverageData } = useSWR(url);
  //  const coverageData = { ...fakeData };
  return (
    <div className="card-col col s12 m12 l12 ">
      {!coverageData ? (
        <LoadingCard card_heading={`${coverage_card.card_heading}`} />
      ) : (
        <div className="card data-card-coverage">
          <img
            className="img card-corner"
            src={coverage_card.conrner_right_top_img}
            alt="card-corner"
          />

          <div className="card-title">{coverage_card.card_heading}</div>
          <div className="card-subtitle">
            {coverageData.total_outlet}
            <p>Total outlets</p>
          </div>

          <div className="card-body">
            <div className="card-content-container">
              <div className="row1">
                <div className="stats">
                  <div className="numbers">
                    <span className="out-of">
                      {coverageData["today_coverage"].call_generates}
                      <p className="coverage-subTitle">Generated call</p>
                    </span>
                  </div>
                  <div className="description">Today</div>
                </div>
                <div className="divide"></div>
                <div className="stats">
                  <div className="numbers">
                    <span className="out-of">
                      {coverageData["yesterday_coverage"].call_generates}
                      <p className="coverage-subTitle">Generated call</p>
                    </span>
                  </div>
                  <div className="description">Yesterday</div>
                </div>
                <div className="divide"></div>
                <div className="stats">
                  <div className="numbers">
                    <span className="out-of">
                      {coverageData["week_ago_coverage"].call_generates}
                      <p className="coverage-subTitle">Generated call</p>
                    </span>
                  </div>
                  <div className="description">Week ago</div>
                </div>
                <div className="divide"></div>
                <div className="stats">
                  <div className="numbers">
                    <span className="out-of">
                      {coverageData["mtd_coverage"].call_generates}
                      <p className="coverage-subTitle">Generated call</p>
                    </span>
                    {/* <span className="out-of" style={{ color: "green" }}>
                      {coverageData["mtd_coverage"].percentage}%
                      <p className="coverage-subTitle">Percentage</p>
                    </span> */}
                  </div>
                  <div className="description">MTD</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

CoverageCard.propTypes = {
  /**
   * Current date to send fetch request for data on that particular date
   */
  date: PropTypes.instanceOf(Date).isRequired,
  /**
   * Object of filters selected from the Filter Element component to send fetch request accordingly
   */
  filterElement: PropTypes.object.isRequired,
};

export default CoverageCard;
